import React, {
  FC, useEffect, useState,
} from 'react';
import { FaXmark, FaMagnifyingGlass, FaAngleDown, FaAngleUp } from "react-icons/fa6";
import {
  Row, Button, Column,
  Wrapper, AButton,
} from './Styles';
import { telWhite, emailWhite } from '../../../../assets/Base64Image';
import { getWindowHeight } from '../../../../lib/utils/utils';

const FAQModal: FC<Props> = ({
  setShowModal,
  faqTarget = 'all', // 帮助对象，住户/司机
  isEnglish,
}) => {
  const [searchText, setSearchText] = useState<string>('');
  const [showSearchItemList, setShowSearchItemList] = useState<boolean>(false);
  const [searchItemList, setSearchItemList] = useState<{ id: string; title: string; content: string }[]>([]);
  const [selectedSearchItemId, setSelectedSearchItemId] = useState<string>();
  const [showContent, setShowContent] = useState<{ [key: string]: boolean}>({});

  // 住户问题 英文
  const residentEnFAQ: { id: string; title: string; content: string }[] = [{
    id: 're' + 1,
    title: 'Do I need to pay to use the locker?',
    content: 'No. Foodifox lockers are completely free for residents’ food storage.',
  }, {
    id: 're' + 2,
    title: 'How can I log in to the pick-up webpage?',
    content: 'Using your mobile phone, scan the QR code located on the TV screen or the poster next to the scanner and follow the prompts.',
  }, {
    id: 're' + 3,
    title: 'What happens if my pick-up code (four digital numbers) can’t open the door?',
    content: 'Your driver may have given you the wrong code. Contact your driver or call 1300 359 889 for assistance.',
  }, {
    id: 're' + 4,
    title: 'What happens if my driver doesn’t send me the pick-up code?',
    content: 'The driver might have sent you the pick-up code via mobile or In-app messages, check to see if a message has been received. Contact your driver or contact Foodifox on 1300 359 889 for assistance. ',
  }, {
    id: 're' + 5,
    title: 'What happens if my mobile signal is bad and I can’t open the pick-up webpage?',
    content: 'Try to connect to free WIFI, if any; otherwise, walk closer to the front entrance.',
  }, {
    id: 're' + 6,
    title: 'What happens if my food is spilt in the locker?',
    content: 'Call Foodifox on 1300 359 889 or report via the pick-up page.',
  }, {
    id: 're' + 7,
    title: 'What happens if I receive a wrong or incomplete order?',
    content: 'If this happens, please contact the driver or food delivery platform.',
  }, {
    id: 're' + 8,
    title: 'What happens if I accidentally close the locker door without completing the pick-up?',
    content: 'You will have one minute to reopen the locker, this can be done by pressing the reopen button on the webpage.',
  }, {
    id: 're' + 9,
    title: 'What happens if the locker screens are blank and I can’t find the QR code on the TV screen?',
    content: 'There is a poster next to the scanner, by scanning the QR code, it can direct you to the pick-up webpage.',
  }, {
    id: 're' + 10,
    title: 'Can I refuse to use the locker for my food delivery order?',
    content: 'Yes, you have the right not to use the locker. However, building management will no longer allow food to be left unattended in the lobby. Furthermore, building management will not be responsible for any missing food.',
  }, {
    id: 're' + 11,
    title: 'How long can my food be left in the locker?',
    content: 'You have 2 hours to pick up your food, after this time the locker door will be permanently locked for both driver and customer to access. If you have any issues accessing your food you should call Foodifox on 1300 359 889.',
  }, {
    id: 're' + 12,
    title: 'Will I be charged if I can’t collect my food order within 120 minutes?',
    content: 'No. Foodifox locker does not charge any fees or overdue fees. Please contact us during business hours if you are unable to collect your delivery within a reasonable timeframe. However, for food safety issues, your food will be disposed of over 8 hours. ',
  }, {
    id: 're' + 13,
    title: 'What happens if my order is oversized and it doesn’t fit in the locker?',
    content: 'Your driver will deliver any oversized order manually.',
  }];

  // 住户问题 中文
  const residentCnFAQ: { id: string; title: string; content: string }[] = [{
    id: 'rc' + 1,
    title: '我需要付费使用取餐柜吗？',
    content: '不需要的，Foodifox取餐柜对取餐客户是完全免费的。',
  }, {
    id: 'rc' + 2,
    title: '我如何打开取餐页？',
    content: '使用您的的手机扫描电视屏幕或柜子上的二维码打开网页。',
  }, {
    id: 'rc' + 3,
    title: '输入我的取餐码（四位数字）之后柜门没有打开。',
    content: '请联系您的司机或联系Foodifox支持人员1300 359 889帮助您取餐，你的司机可能不小心提供了错误的取餐码。',
  }, {
    id: 'rc' + 4,
    title: '司机没有发送取餐码给我。',
    content: '请查看您的短信或点餐平台内的收件箱，您的司机可能会通过短信或您点餐的app的内置沟通平台发送取餐码，如果都没有，请联系您的司机或联系Foodifox支持人员1300 359 889帮助您取餐。',
  }, {
    id: 'rc' + 5,
    title: '我的手机没有网络打不开取餐页面。',
    content: '请尝试连接附近的WIFI或走到离室外较近的地方获取更好的信号。',
  }, {
    id: 'rc' + 6,
    title: '我的食物洒在取餐柜里了。',
    content: '请点击取餐页面上的“反馈柜子问题”或联系Foodifox支持人员1300 359 889进行清理。',
  }, {
    id: 'rc' + 7,
    title: '我收到的餐品和订单不符（错餐或漏餐）。',
    content: '请联系您的司机或点餐平台。',
  }, {
    id: 'rc' + 8,
    title: '我不小心关门了但我的餐品还在取餐柜里。',
    content: '点击取餐页面上的“重新开柜”按钮，一分钟内有效。如果超过了一分钟，请联系Foodifox支持人员1300 359 889',
  }, {
    id: 'rc' + 9,
    title: '电视屏幕黑屏了或电视屏幕上没有二维码。',
    content: '取餐柜上的海报也有二维码供客户扫描进行取餐。',
  }, {
    id: 'rc' + 10,
    title: '我不想使用柜子取餐',
    content: '请提前与您的司机进行协商。大楼管理员可能会强制进入大楼的送餐司机使用取餐柜防止餐品丢失等问题。',
  }, {
    id: 'rc' + 11,
    title: '我的外卖可以在取餐柜里放多久？',
    content: '2个小时，如果超时您的取餐码会失效。联系Foodifox支持人员1300 359 889取餐。',
  }, {
    id: 'rc' + 12,
    title: '如果我2小时内不取餐会被收取费用吗？',
    content: '不会的，Foodifox取餐柜对取餐客户是完全免费的。如果您无法在2小时内取餐，请联系Foodifox支持人员1300 359 889。请注意，由于澳洲食品安全相关法规法条，如果您超过了8小时未取餐，您的餐食可能会被扔掉。',
  }, {
    id: 'rc' + 13,
    title: '我的外卖不在取餐柜里',
    content: '请联系您的司机或点餐平台。',
  }, {
    id: 'rc' + 14,
    title: '外卖尺寸过大',
    content: '请联系您的司机进行面对面送餐。',
  }];

  // 司机问题 英文
  const driverEnFAQ: { id: string; title: string; content: string }[] = [{
    id: 'de' + 1,
    title: 'Do I need to pay to use the lockers?',
    content: 'No. Foodifox locker is completely free for drivers’ food delivery.',
  }, {
    id: 'de' + 2,
    title: 'Do I need to enter my mobile number for every drop-off? ',
    content: 'No, it is only for the first-time verification. However, if you change your SIM card/ mobile, you need to do the verification again.',
  }, {
    id: 'de' + 3,
    title: 'What happens if food is spilt in the locker?',
    content: 'Call Foodifox on 1300 359 889 or report via the pick-up page',
  }, {
    id: 'de' + 4,
    title: 'What happens if the locker screens are blank and I can’t find the QR code on the TV screen?',
    content: 'There is a poster next to the scanner, by scanning the QR code, it can direct you to the drop-off or pick-up page.',
  }, {
    id: 'de' + 5,
    title: 'How can I send the pick-up code (four digital numbers) to the user?',
    content: 'You can copy the pick-up code text or screenshot and send it via in-app message or text message.\n' +
      'We encourage Uber and Menulog drivers to CALL the recipient to provide the pick-up code in case the In-app chat expires after completing the order.',
  }, {
    id: 'de' + 6,
    title: 'Can I reopen the locker if I have made a mistake or have an incomplete delivery? ',
    content: 'Yes, you have one minute to reopen the locker (by pressing the reopen button on the webpage), or after one minute, you need to input the pickup code to reopen the locker.',
  }, {
    id: 'de' + 7,
    title: 'How long can the food be stored in the locker?',
    content: 'Up to 120 minutes, after this time the locker door will be permanently locked for both driver and customer to access.',
  }, {
    id: 'de' + 8,
    title: 'Can all food items be delivered to the locker?',
    content: 'No. If you are delivering over 13in pizza, oversize bubble tea or stack up meals in one bag. This will not fit into the locker, and you will need to contact the customer directly for a manual delivery.',
  }, {
    id: 'de' + 9,
    title: 'Do I have to scan the QR code located at each location before delivering the food?',
    content: 'YES! Each QR code is specific to each locker location.',
  }, {
    id: 'de' + 10,
    title: 'Where can I find all my delivery history and pick-up code in case I forget or am given the wrong one?',
    content: 'Delivery history and other functions will be launched in the future with the driver login function.',
  }];

  // 司机问题 中文
  const driverCnFAQ: { id: string; title: string; content: string }[] = [{
    id: 'dc' + 1,
    title: '我使用送餐柜需要付费吗？',
    content: '不需要的， Foodifox送餐柜对送餐司机是完全免费的。',
  }, {
    id: 'dc' + 2,
    title: '每次送餐都需要输入我的手机号吗？',
    content: '不需要，这仅用于首次验证。 但如果您更换SIM卡/手机，则需要重新进行验证。',
  }, {
    id: 'dc' + 3,
    title: '外卖洒在柜子里了。',
    content: '请点击取餐页面上的“反馈柜子问题”或联系Foodifox支持人员1300 359 889进行清理。',
  }, {
    id: 'dc' + 4,
    title: '电视屏幕黑屏了或电视屏幕上没有二维码。',
    content: '送餐柜上的海报也有二维码供客户扫描进行取餐。',
  }, {
    id: 'dc' + 5,
    title: '我如何发送取餐码（四位数字）给客户取餐？',
    content: '您可以复制取餐码或手机截图，发送短信或在送餐平台内的聊天发送给客户。我们鼓励 Uber 和 Menulog 司机致电收件人提供取餐码，以防送餐平台内的对话在完成订单后关闭。',
  }, {
    id: 'dc' + 6,
    title: '放错餐或漏放餐',
    content: '点击页面上的“重新开柜”按钮，一分钟内有效。如果超过了一分钟，请输入取餐码重新开门。您输入取餐码不会影响客户取餐。或联系Foodifox支持人员1300 359 889。',
  }, {
    id: 'dc' + 7,
    title: '外卖可以在取餐柜里放多久?',
    content: '2个小时，如果超时客户的取餐码会失效。如需帮助，请联系Foodifox支持人员1300 359 889。',
  }, {
    id: 'dc' + 8,
    title: '所有外卖都可以使用送餐吗？',
    content: '如果您要配送超过 13 英寸的披萨、超大号奶茶或将餐品叠放在一个袋子中。 这无法放入送餐柜，您需要直接联系客户进行手动交付。',
  }, {
    id: 'dc' + 9,
    title: '外卖无法放入送餐柜',
    content: '请直接联系客户进行面对面交付。',
  }, {
    id: 'dc' + 10,
    title: '每次送餐前都要扫描每个地点的二维码吗？',
    content: '是的，每个送餐柜都有不同的二维码。',
  }, {
    id: 'dc' + 11,
    title: '我在哪里可以找到配送历史和取餐码？',
    content: '配送历史等更多功能后续会持续加入，敬请关注。如果您有更多想法，可以联系我们，发送邮件至hello@foodifox.com。',
  }];

  useEffect(() => {
    const initShowContent: { [key: string]: boolean } = {};
    for (let i = 0; i < residentEnFAQ.length; i += 1) {
      const { title } = residentEnFAQ[i];
      initShowContent[title] = false;
    }
    for (let i = 0; i < residentCnFAQ.length; i += 1) {
      const { title } = residentCnFAQ[i];
      initShowContent[title] = false;
    }
    for (let i = 0; i < driverEnFAQ.length; i += 1) {
      const { title } = driverEnFAQ[i];
      initShowContent[title] = false;
    }
    for (let i = 0; i < driverCnFAQ.length; i += 1) {
      const { title } = driverCnFAQ[i];
      initShowContent[title] = false;
    }

    setShowContent({ ...initShowContent });
  }, []);

  useEffect(() => {
    if (isEnglish) {
      setSearchItemList(('all' === faqTarget ? [...residentEnFAQ, ...driverEnFAQ] : ('recipient' === faqTarget ? residentEnFAQ : driverEnFAQ)));
    }
    else {
      setSearchItemList(('all' === faqTarget ? [...residentCnFAQ, ...driverCnFAQ] : ('recipient' === faqTarget ? residentCnFAQ : driverCnFAQ)));
    }
  }, [faqTarget, isEnglish]);

  /**
   * 获取内容
   * @param cnList
   * @param enList
   */
  const getListContent = (cnList: { id: string; title: string; content: string }[], enList: { id: string; title: string; content: string }[]) => {
    return (
      <>
        {
          isEnglish ? (
            <>
              {
                enList.map(({ id, title, content }, index) => {
                  return (
                    <div style={{ paddingLeft: '5%', paddingRight: '5%', background: selectedSearchItemId === id ? '#dff5f1' : undefined }}>
                      {
                        selectedSearchItemId !== id && (
                          <div style={{ height: '1px', background: '#11202B', opacity: 0.1 }}></div>
                        )
                      }
                      <Row
                        id={id}
                        style={{ justifyContent: 'space-between' }}
                        onClick={() => {
                          // 设置选中的项
                          setSelectedSearchItemId(!showContent[title] ? id : undefined);
                          showContent[title] = !showContent[title];
                          setShowContent({ ...showContent });
                        }}
                      >
                        <Column
                          style={{ fontSize: '16px', fontFamily: showContent[title] ? 'Squad-Bold, Squad' : 'Squad-SemiBold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '21px', minHeight: '40px', paddingTop: '10px', paddingBottom: '10px', alignItems: 'flex-start' }}
                        >
                          {title}
                        </Column>
                        <Column style={{ minWidth: '25px' }}>
                          {
                            showContent[title] ? (
                              <FaAngleUp />
                            ) : (
                              <FaAngleDown />
                            )
                          }
                        </Column>
                      </Row>
                      {
                        showContent[title] && (
                          <div style={{ fontSize: '16px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '22px', marginBottom: '10px', background: selectedSearchItemId === id ? '#dff5f1' : undefined }}>
                            {content}
                          </div>
                        )
                      }
                      {
                        ((index + 1) === enList.length && selectedSearchItemId !== id) && (
                          <div style={{ height: '1px', background: '#11202B', opacity: 0.1 }}></div>
                        )
                      }
                    </div>
                  );
                })
              }
            </>
          ) : (
            <>
              {
                cnList.map(({ id, title, content }, index) => {
                  return (
                    <div style={{ paddingLeft: '5%', paddingRight: '5%', background: selectedSearchItemId === id ? '#dff5f1' : undefined }}>
                      {
                        selectedSearchItemId !== id && (
                          <div style={{ height: '1px', background: '#11202B', opacity: 0.1 }}></div>
                        )
                      }
                      <Row
                        id={id}
                        style={{ justifyContent: 'space-between' }}
                        onClick={() => {
                          // 设置选中的项
                          setSelectedSearchItemId(!showContent[title] ? id : undefined);
                          showContent[title] = !showContent[title];
                          setShowContent({ ...showContent });
                        }}
                      >
                        <Column
                          style={{ fontSize: '16px', fontFamily: 'PingFangSC-Medium, PingFang SC', fontWeight: 500, color: '#11202B', lineHeight: '22px', minHeight: '40px', paddingTop: '10px', paddingBottom: '10px', alignItems: 'flex-start' }}
                        >
                          {title}
                        </Column>
                        <Column style={{ minWidth: '25px' }}>
                          {
                            showContent[title] ? (
                              <FaAngleUp />
                            ) : (
                              <FaAngleDown />
                            )
                          }
                        </Column>
                      </Row>
                      {
                        showContent[title] && (
                          <div style={{ fontSize: '16px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '22px', marginBottom: '10px' }}>
                            {content}
                          </div>
                        )
                      }
                      {
                        ((index + 1) === cnList.length && selectedSearchItemId !== id) && (
                          <div style={{ height: '1px', background: '#11202B', opacity: 0.1 }}></div>
                        )
                      }
                    </div>
                  );
                })
              }
            </>
          )
        }
      </>
    );
  };

  /* 帮助 */
  return (
    <Wrapper>
      <div style={{ width: '100%', height: '90%', background: '#ffffff', position: 'fixed', bottom: 0, zIndex: 3 }}>
        {/* 标题 */}
        <Row style={{ justifyContent: 'space-between', marginTop: '5%' }}>
          <div style={{ width: '20px', height: '20px' }}>&nbsp;</div>
          {
            isEnglish ? (
              <div style={{ height: '20px', fontSize: '20px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '26px' }}>
                FAQ
              </div>
            ) : (
              <div style={{ height: '20px', fontSize: '20px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '28px' }}>
                常见问题
              </div>
            )
          }
          <Button
            onClick={() => setShowModal(false)}
            style={{ height: '20px', width: '20px', marginRight: '10px', fontSize: '16px' }}
          >
            <FaXmark style={{ color: '#11202B' }} />
          </Button>
        </Row>

        {/* 横线 */}
        <div style={{ width: '90%', height: '2px', background: '#11202B', opacity: 0.1, margin: '5% auto 0 auto' }}></div>

        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          {
            isEnglish ? (
              <div style={{ fontFamily: 'Squad-Bold, Squad', fontSize: '25px', fontWeight: 'bold', color: '#11202B' }}>
                How can we help you?
              </div>
            ) : (
              <div style={{ fontSize: '25px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 'bold', color: '#11202B', lineHeight: '26px' }}>
                <span style={{ fontFamily: 'Squad-Bold, Squad' }}>Foodifox</span>帮助中心
              </div>
            )
          }
        </div>

        <div style={{ height: '48px', background: '#FFFFFF', borderRadius: '36px', border: '1px solid #11202B', width: '90%', marginTop: '20px', marginLeft: '5%', marginRight: '5%', position: 'relative', zIndex: 2 }}>
          <Row style={{ height: '48px', alignItems: 'center', marginLeft: '15px', width: '100%' }}>
            {
              <input
                style={{
                  border: 'none',
                  outline: 'none',
                  fontSize: '16px',
                  fontFamily: 'Squad-Regular, Squad',
                  fontWeight: 400,
                  color: '#11202B',
                  backgroundColor: '#ffffff',
                  lineHeight: '21px',
                  width: '80%',
                  height: '40px',
                }}
                type="text"
                placeholder={isEnglish ? 'Search help' : '搜索问题'}
                value={searchText}
                onFocus={() => {
                  if (searchText) {
                    setShowSearchItemList(true);
                  }
                }}
                onChange={(e) => {
                  setShowSearchItemList(!!e.target.value);
                  setSearchText(e.target.value);
                  if (!e.target.value) {
                    setSelectedSearchItemId(undefined);
                  }
                }}
              />
            }
            <Button>
              <FaMagnifyingGlass style={{ fontSize: 20, color: '#11202B', marginRight: 15 }} />
            </Button>
          </Row>
        </div>
        {
          (searchText && showSearchItemList && searchItemList.filter(({ title }) => title.toLowerCase().includes(searchText.toLowerCase())).length > 0) && (
            <div style={{ width: '90%', maxHeight: (getWindowHeight() * 0.3) + 'px', marginLeft: '5%', marginRight: '5%', background: '#FFFFFF', border: '1px solid #11202B', borderRadius: '18px', position: 'absolute', zIndex: 1, paddingTop: '35px', paddingBottom: '15px', marginTop: '-33px' }}>
              <div style={{ width: '100%', maxHeight: (getWindowHeight() * 0.3 - 10) + 'px', overflow: 'auto' }}>
                {
                  isEnglish ? (
                    <>
                      {
                        searchItemList.map(({ id, title }, index) => {
                          if (title.toLowerCase().includes(searchText.toLowerCase())) {
                            return (
                              <>
                                <div
                                  onClick={() => {
                                    // 隐藏搜索列表
                                    setShowSearchItemList(false);
                                    // 设置选中的搜索项
                                    setSelectedSearchItemId(id);
                                    // 显示内容
                                    showContent[title] = !showContent[title];
                                    setShowContent({ ...showContent });
                                    // 滚动到指定位置
                                    document.querySelector('#' + id)?.scrollIntoView();
                                  }}
                                  style={{ fontSize: '16px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '21px', padding: '10px 20px' }}
                                >
                                  {title}
                                </div>
                                {
                                  index + 1 < searchItemList.length && (
                                    <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                                      <div style={{ height: '1px', background: '#11202B', opacity: 0.1 }}></div>
                                    </div>
                                  )
                                }
                              </>
                            );
                          }
                        })
                      }
                    </>
                  ) : (
                    <>
                      {
                        searchItemList.map(({ id, title }, index) => {
                          if (title.toLowerCase().includes(searchText.toLowerCase())) {
                            return (
                              <>
                                <div
                                  onClick={() => {
                                    // 隐藏搜索列表
                                    setShowSearchItemList(false);
                                    // 设置选中的搜索项
                                    setSelectedSearchItemId(id);
                                    // 显示内容
                                    showContent[title] = !showContent[title];
                                    setShowContent({ ...showContent });
                                    // 滚动到指定位置
                                    document.querySelector('#' + id)?.scrollIntoView();
                                  }}
                                  style={{ fontSize: '16px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '21px', padding: '10px 20px' }}
                                >
                                  {title}
                                </div>
                                {
                                  index + 1 < searchItemList.length && (
                                    <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                                      <div style={{ height: '1px', background: '#11202B', opacity: 0.1 }}></div>
                                    </div>
                                  )
                                }
                              </>
                            );
                          }
                        })
                      }
                    </>
                  )
                }
              </div>
            </div>
          )
        }

        <div style={{ overflow: 'auto', height: '60%', marginTop: '10px' }}>
          {
            ['recipient', 'all'].includes(faqTarget) && (
              <>
                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                  {
                    isEnglish ? (
                      <div style={{ fontFamily: 'Squad-Bold, Squad', fontSize: '20px', fontWeight: 'bold', color: '#11202B' }}>
                        FAQ for Resident
                      </div>
                    ) : (
                      <div style={{ fontSize: '20px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 'bold', color: '#11202B' }}>
                        住户常见问题
                      </div>
                    )
                  }
                </div>

                {/* 住户帮助 */}
                <div className="hidden-scroll" style={{ width: '100%', height: '90%', overflow: 'auto', marginTop: '10px', textAlign: 'left' }}>
                  {
                    getListContent(residentCnFAQ, residentEnFAQ)
                  }
                </div>
              </>
            )
          }

          {
            ['driver', 'all'].includes(faqTarget) && (
              <>
                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                  {
                    isEnglish ? (
                      <div style={{ fontFamily: 'Squad-Bold, Squad', fontSize: '20px', fontWeight: 'bold', color: '#11202B' }}>
                        FAQ for Driver
                      </div>
                    ) : (
                      <div style={{ fontSize: '20px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 'bold', color: '#11202B' }}>
                        司机常见问题
                      </div>
                    )
                  }
                </div>

                {/* 司机帮助 */}
                <div className="hidden-scroll" style={{ width: '100%', height: '90%', overflow: 'auto', marginTop: '10px', textAlign: 'left' }}>
                  {
                    getListContent(driverCnFAQ, driverEnFAQ)
                  }
                </div>
              </>
            )
          }
        </div>
      </div>

      {/* 联系电话和邮箱按钮 */}
      <div style={{ width: '100%', background: '#ffffff', position: 'fixed', bottom: 0, zIndex: 3, boxShadow: '8px 0px 14px 0px rgba(0,0,0,0.13)' }}>
        {
          isEnglish ? (
            <div style={{ fontFamily: 'Squad-Bold, Squad', fontSize: '14px', fontWeight: 'bold', color: '#11202B', opacity: 0.57, textAlign: 'center', marginTop: '12px' }}>
              Still Stuck? Please contact us!
            </div>
          ) : (
            <div style={{ fontSize: '12px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', opacity: 0.57, textAlign: 'center', marginTop: '12px' }}>
              如果以上解答无法帮助解决你的问题，请联系我们
            </div>
          )
        }
        <Row style={{ width: '90%', marginTop: '15px', marginLeft: '5%', justifyContent: 'center', alignItems: 'center', paddingBottom: '15px' }}>
          <AButton
            href="tel:1300359889"
            style={{ width: '164px', height: '43px', background: '#00B595', borderRadius: '33px' }}
          >
            <Row>
              <img src={telWhite} style={{ width: '18px', height: '18px', marginRight: '5px' }} />
              {
                isEnglish ? (
                  <div style={{ fontSize: '18px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF' }}>
                    Call Us
                  </div>
                ) : (
                  <div style={{ fontSize: '18px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF' }}>
                    拨打电话
                  </div>
                )
              }
            </Row>
          </AButton>
          <AButton
            href="mailto:hello@foodifox.com"
            style={{ width: '164px', height: '43px', background: '#00B595', borderRadius: '33px', marginLeft: '10px' }}
          >
            <Row>
              <img src={emailWhite} style={{ width: '18px', height: '18px', marginRight: '5px' }} />
              {
                isEnglish ? (
                  <div style={{ fontSize: '18px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF' }}>
                    Email Us
                  </div>
                ) : (
                  <div style={{ fontSize: '18px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF' }}>
                    发送邮件
                  </div>
                )
              }
            </Row>
          </AButton>
        </Row>
      </div>
    </Wrapper>
  );
};

export interface Props {
  setShowModal: (isShow: boolean) => void;
  faqTarget?: string;
  isEnglish: boolean;
}

export default FAQModal;
